var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{staticClass:"table-load-overlay d-flex justify-content-center align-items-center"},[_c('fa',{attrs:{"icon":['fas', 'circle-notch'],"spin":"","size":"6x"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }